module.exports = __webpack_public_path__ + "assets/icon_flow_highlight.2b124844.svg";